import { render, staticRenderFns } from "./TabTokenItem.vue?vue&type=template&id=0737cc57"
import script from "./TabTokenItem.vue?vue&type=script&lang=js"
export * from "./TabTokenItem.vue?vue&type=script&lang=js"
import style0 from "./TabTokenItem.vue?vue&type=style&index=0&id=0737cc57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports